import { render, staticRenderFns } from "./flexbox.vue?vue&type=template&id=3e0358f5&"
import script from "./flexbox.vue?vue&type=script&lang=js&"
export * from "./flexbox.vue?vue&type=script&lang=js&"
import style0 from "./flexbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.3.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/erp_Product/erp_front/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3e0358f5', component.options)
    } else {
      api.reload('3e0358f5', component.options)
    }
    module.hot.accept("./flexbox.vue?vue&type=template&id=3e0358f5&", function () {
      api.rerender('3e0358f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/flexbox/flexbox.vue"
export default component.exports